// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import {
  animationClass,
} from '@vroskus/library-helpers/dist/browser';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate;

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const ErrorView = function ({
  main,
  t,
}: $Props) {
  return (main.error !== null ? (
    <div className={`Error ${animationClass('fadeIn')} mb-5`}>
      <div className={'alert alert_outlined alert_danger bg-white-tr'}>
        <strong className={'uppercase'}>
          {`${t('Error')}! `}
        </strong>
        {main.error}
      </div>
    </div>
  ) : null);
};

export default ErrorView;
